import React from 'react';
import Page from "../../../components/pages/form/Page/Page";

const PagePage = () => {
    return <Page />
};

export default PagePage;